import React, { useState, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import { useUser } from "../config/userProvider.js";
import BackHeader from "../components/backHeader.js";
import Cropper from "react-easy-crop";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { apiurl } from "../config/config";
import axios from "axios";




const Account = () => {
  const { userData, userType } = useUser();
  console.log("userData is:", userData);
  const [activeAccount, setActiveAccount] = useState("profile");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  // const [isVerified, setIsVerified] = useState({
  //   email: userData?.verificationDetails?.isEmailVerified,
  //   phone: userData?.verificationDetails?.isPhoneVerified,
  // });

  const [isVerified] = useState({
    email: userData?.verificationDetails?.isEmailVerified,
    phone: userData?.verificationDetails?.isPhoneVerified,
  });
  const [otp, setOtp] = useState("");

  const [isEmailPopupOpen, setEmailPopupOpen] = useState(false);
  const [isPhonePopupOpen, setPhonePopupOpen] = useState(false);

  const [newPhone, setNewPhone] = useState("");
  const [isPhoneChangePopupOpen, setPhoneChangePopupOpen] = useState(false);
  const [isVerifyChoicePopupOpen, setVerifyChoicePopupOpen] = useState(false);

  const openEmailPopup = () => {
    setEmailPopupOpen(true);
    setVerifyChoicePopupOpen(false);
  };
  const closeEmailPopup = () => setEmailPopupOpen(false);
  const openPhonePopup = () => { setPhonePopupOpen(true); setVerifyChoicePopupOpen(false); };
  const closePhonePopup = () => setPhonePopupOpen(false);

  console.log("isVerified.email", isVerified.email);
  console.log("isVerified.phone", isVerified.phone);

  // const verificationDetails = userData?.verificationDetails;

  // const isEmailVerified = verificationDetails?.isEmailVerified;
  // const isPhoneVerified = verificationDetails?.isPhoneVerified;

  const handleOtpChange = (e) => setOtp(e.target.value);

  // useEffect(() => {
  //   if (userData.userType === "superadmin") {
  //     if (!isEmailVerified && !isPhoneVerified) {
  //       setIsVerified({ email: false, phone: false });
  //     } else if (isEmailVerified && !isPhoneVerified) {
  //       setIsVerified({ email: true, phone: false });
  //     } else if (!isEmailVerified && isPhoneVerified) {
  //       setIsVerified({ email: false, phone: true });
  //     } else if (isEmailVerified && isPhoneVerified) {
  //       setIsVerified({ email: true, phone: true });
  //     }
  //   }
  // }, [userData, verificationDetails]);

  const onClosePopup = () => {
    setShowPopup(false);
    setSelectedImage(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
    }
  };

  const handleCropComplete = useCallback(() => {
    // Logic for handling cropped image
    alert("Cropped image saved!");
    setShowPopup(false);
  }, []);

  const sendEmailOtp = async () => {

    try {
      // Prepare the payload
      const payload = {
        ownerName: userData.name,
        recipientEmail: userData.email,
        storeName: "",
      };

      console.log("Payload being sent:", payload);

      // Make the API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/generate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response", response);
      // Handle response
      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP sent successfully");
        console.log("OTP Modal Opened:", response?.data?.message);
        openEmailPopup();
      } else {
        toast.error(
          response?.data?.message || "OTP Sent failure, Please try again"
        );
      }
    } catch (error) {
      // Handle and log errors
      console.error(
        "Error generating OTP:",
        error.response?.data || error.message
      );
      toast.error(
        "An error occurred while sending OTP. Please try again later."
      );
    }
  };

  const handleEmailOtpSubmit = async () => {
    try {
      // Prepare the payload
      const payload = {
        otp,
        email: userData.email,
      };

      // console.log("Payload being sent for OTP verification:", payload);

      // API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP verified successfully");
        closeEmailPopup();
      } else {
        toast.error(
          response?.data?.message ||
          "OTP verification failed. Please try again."
        );
      }
    } catch (error) {
      // Handle errors
      console.error(
        "Error verifying OTP:",
        error.response?.data || error.message
      );
      toast.error(
        "An error occurred during OTP verification. Please try again."
      );
    }
  };
  const sendPhoneVerifyOtp = async () => {

    try {
      const payload = {
        ownerName: userData.name,
        recipientEmail: userData.email,
        storeName: "",
      };

      console.log("Payload being sent:", payload);

      // Make the API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/generate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response", response);
      // Handle response
      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP sent successfully");
        console.log("OTP Modal Opened:", response?.data?.message);
        openPhonePopup();
      } else {
        toast.error(
          response?.data?.message || "OTP Sent failure, Please try again"
        );
      }
    } catch (error) {
      // Handle and log errors
      console.error(
        "Error generating OTP:",
        error.response?.data || error.message
      );
      toast.error(
        "An error occurred while sending OTP. Please try again later."
      );
    }
  };


  const handlePhoneChange = () => {
    if (isVerified.email || isVerified.phone) {
      setPhoneChangePopupOpen(true);
    } else {
      setVerifyChoicePopupOpen(true);
    }
  };

  const handlePhoneOtpSubmit = async () => {
    try {
      // Prepare the payload
      const payload = {
        otp,
        email: userData.email,
      };

      // console.log("Payload being sent for OTP verification:", payload);

      // API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP verified successfully");
        closePhonePopup();
      } else {
        toast.error(
          response?.data?.message ||
          "OTP verification failed. Please try again."
        );
      }
    } catch (error) {
      // Handle errors
      console.error(
        "Error verifying OTP:",
        error.response?.data || error.message
      );
      toast.error(
        "An error occurred during OTP verification. Please try again."
      );
    }
  };


  const handlePhoneNumberChange = async () => {
    try {
      const payload = {
        ownerName: userData.name,
        recipientPhone: newPhone,
        storeName: "",
      };
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/generate`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.data?.success === "true") {
        toast.success("OTP sent to new phone number");
        setPhoneChangePopupOpen(false);
        setPhonePopupOpen(true);
      }
    } catch (error) {
      toast.error("Error sending OTP to new phone");
    }
  };

  const handleVerificationChoice = async (type) => {
    try {
      if (type === "email") {
        await sendEmailOtp();
      } else {
        await sendPhoneVerifyOtp();
      }
    } catch (error) {
      toast.error(`Error sending ${type} OTP`);
    }
  };

  return (
    <Layout>
      <Container>
        <BackHeader
          backButton={true}
          link="/dashboard"
          title="Account Settings"
          backHeaderClass={"pl-2"}
          backHeaderTitleClass={"text-black"}
        />
        {/* <div className="font-semibold text-xl py-1 px-4">Account Settings</div> */}
        <div className=" flex md:flex-row flex-col gap-2 w-full md:h-[95%] p-2 rounded-xl h-full">
          <div className="md:w-1/6 w-full md:h-full flex  md:flex-col justify-start items-start gap-2 bg-white border rounded-lg  p-2">
            <button
              style={{ borderWidth: 1 }}
              onClick={() => setActiveAccount("profile")}
              className={` border-zinc-100  text-start capitalize p-2 rounded-md w-full ${activeAccount === "profile"
                ? "bg-black text-white"
                : "bg-zinc-50"
                }  `}
            >
              profile
            </button>
            {/* <button
              style={{ borderWidth: 1 }}
              onClick={() => setActiveAccount("setting")}
              className={` border-zinc-100  text-start capitalize p-2 rounded-md w-full ${activeAccount === "setting"
                ? "bg-black text-white"
                : "bg-zinc-50"
                }  `}
            >
              settings
            </button> */}
          </div>
          <div className="md:w-5/6 w-full bg-white border rounded-lg h-full p-6 font-semibold  gap-5 overflow-y-scroll">
            <div className="flex items-center gap-5">
              <div className="w-16 h-16 bg-slate-700 rounded-full text-white flex justify-center items-center font-semibold text-2xl cursor-pointer">
                {userData.name[0]}
              </div>
              <div>
                <div className="text-base md:text-2xl text-slate-700 tracking-wide">
                  {userData.name}
                </div>
                <div className="text-zinc-400 capitalize">
                  Type: {userData.userType}
                </div>
              </div>
            </div>

            <div className="flex flex-col  gap-3 mt-5">
              <div className="text-base md:text-xl text-slate-700 font-semibold pl-2 tracking-wide">
                Personal
              </div>
              <div className="flex flex-col gap-4 mx-2 flex-wrap">
                <div
                  className={`flex justify-between items-center p-3 md:p-4 rounded-lg h-20 ${isVerified.phone ? "bg-green-100" : "bg-red-100"
                    }`}
                >
                  <div className="flex flex-row gap-5 h-16 items-center">
                    <div
                      className={`w-1 h-[80%] rounded-md ${isVerified.phone ? "bg-green-400" : "bg-red-400"
                        }`}
                    ></div>
                    <div>
                      <TextContainer label="phone number">
                        {userData.phone}
                      </TextContainer>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div>
                      {isVerified.phone === false ? (
                        <div className="flex flex-row gap-4 items-center">
                          <p className="text-sm font-normal hidden lg:flex text-red-400">
                            Phone is not verified, Please Verify.
                          </p>
                          <button
                            className="text-red-400 border text-xs border-red-400 px-2 py-1 rounded-sm"
                            onClick={sendPhoneVerifyOtp}
                          >
                            Verify
                          </button>
                        </div>
                      ) : (
                        <div className="flex flex-row gap-4 items-center">
                          <p className="text-sm font-normal hidden lg:flex text-green-400">
                            Phone is verified.
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-row gap-4 items-center">
                      <button
                        className="text-blue-400 border text-xs border-blue-400 px-2 py-1 rounded-sm"
                        onClick={handlePhoneChange}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className={`flex justify-between items-center p-3 md:p-4 rounded-lg h-20 ${isVerified.email ? "bg-blue-100" : "bg-red-100"
                    }`}
                >
                  <div className="flex flex-row gap-5 h-16 items-center">
                    <div
                      className={`w-1 h-[80%] rounded-md ${isVerified.email ? "bg-blue-400" : "bg-red-400"
                        }`}
                    ></div>
                    <div className="max-w-24 md:max-w-none overflow-scroll">
                      <TextContainer label="email">
                        {userData.email}
                      </TextContainer>
                    </div>
                  </div>
                  <div>
                    {isVerified.email === false ? (
                      <div className="flex flex-row gap-4 items-center">
                        <p className="text-sm font-normal hidden lg:flex text-red-400">
                          Email is not verified, Please Verify.
                        </p>
                        <button
                          className="text-red-400 border text-xs border-red-400 px-2 py-1 rounded-sm"
                          onClick={sendEmailOtp}
                        >
                          Verify
                        </button>
                      </div>
                    ) : (
                      <div className="flex flex-row gap-4 items-center">
                        <p className="text-sm font-normal hidden lg:flex text-blue-400">
                          Email is verified.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="flex flex-col gap-3 mt-5">
              <div className="text-base md:text-2xl font-bold">Store</div>
              <div className="flex items-center gap-12 mx-2 flex-wrap">
                <TextContainer label="Store name">
                  {userData?.storeName}
                </TextContainer>
                <TextContainer label="Store code">
                  {userData?.storeCode}
                </TextContainer>
                <TextContainer label="Store address">
                  {userData?.storeAddress}
                </TextContainer>
              </div>
            </div>
            <div className="flex flex-col gap-3 mt-5">
              <div className="text-2xl font-bold">Permission</div>
              <div className="flex items-center gap-12 mx-2 flex-wrap">
                <TextContainer label="role">
                  {userData?.permission?.role}
                </TextContainer>
                <TextContainer label="orders">
                  {userData?.permission?.orders === true ? "true" : "false"}
                </TextContainer>
                <TextContainer label="products">
                  {userData?.permission?.products === true ? "true" : "false"}
                </TextContainer>
                <TextContainer label="reports">
                  {userData?.permission?.reports === true ? "true" : "false"}
                </TextContainer>
                <TextContainer label="settings">
                  {userData?.permission?.settings === true ? "true" : "false"}
                </TextContainer>
                <TextContainer label="stores">
                  {userData?.permission?.stores === true ? "true" : "false"}
                </TextContainer>
                <TextContainer label="users">
                  {userData?.permission?.users === true ? "true" : "false"}
                </TextContainer>
              </div>
            </div> */}
            <div className="flex flex-col md:flex-row justify-center gap-6 mt-5">
              {/* Store Card */}
              <div className="w-full md:w-[48%] bg-[#f0faf5] border border-[#89d3a8] rounded-lg text-[#002100] tracking-wider">
                <div className="bg-[#ceefdf]  p-4 rounded-t-lg border-b-2 border-dashed border-[#89d3a8]">
                  <h3 className="text-lg font-normal">Store</h3>
                </div>
                <div className="p-4 space-y-3">
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-green-500">
                      Store name
                    </span>
                    <p className="text-base">{userData?.storeDetails?.storeName || "N/A"}</p>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-green-500">
                      Store code
                    </span>
                    <p className="text-base">{userData?.storeDetails?.storeCode || "N/A"}</p>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-green-500">
                      Store Email
                    </span>
                    <p className="text-base">
                      {userData?.storeDetails?.storeEmail || "N/A"}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-green-500">
                      Store address
                    </span>
                    <p className="text-base">
                      {userData?.storeDetails?.storeAddress || "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Permission Card */}
              {userType !== "user" && (
                <div className="w-full md:w-[48%] bg-[#f1e8fd] border border-[#a271bf] rounded-md text-[#530073] tracking-wider">
                  <div className="bg-[#ddc7fa]  p-4 rounded-t-lg border-b-2 border-dashed border-[#a271bf]">
                    <h3 className="text-lg font-normal ">Permission</h3>
                  </div>
                  {/* <div className="border-t border-2 border-dashed border-purple-400"></div> */}
                  <div className="p-4 grid grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-purple-600">
                        Role
                      </span>
                      <p className="text-base ">
                        {userData?.userType || "N/A"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Orders</span>
                      <p className="text-base ">
                        {userData?.permissions?.orders ? "true" : "false"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Products</span>
                      <p className="text-base ">
                        {userData?.permissions?.products ? "true" : "false"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Reports</span>
                      <p className="text-base ">
                        {userData?.permissions?.reports ? "true" : "false"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Settings</span>
                      <p className="text-base ">
                        {userData?.permissions?.settings ? "true" : "false"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Stores</span>
                      <p className="text-base ">
                        {userData?.permissions?.stores ? "true" : "false"}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-purple-600">Users</span>
                      <p className="text-base ">
                        {userData?.permissions?.users ? "true" : "false"}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div>
          <TextContainer label="name">{userData?.name}</TextContainer>
        </div> */}

        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="relative bg-white rounded-lg shadow-lg w-[90%] max-w-2xl">
              {/* Popup Header */}
              <div className="flex justify-between items-center px-4 py-2 border-b">
                <h2 className="text-lg font-bold">Crop Your Image</h2>
                <button onClick={onClosePopup} className="text-gray-500">
                  <IoClose size={24} />
                </button>
              </div>

              {/* Popup Content */}
              <div className="p-4">
                {!selectedImage ? (
                  <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 p-6 rounded-md">
                    <label
                      htmlFor="file-input"
                      className="text-blue-500 cursor-pointer underline"
                    >
                      Select Image
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                    <p className="mt-2 text-gray-500">
                      or drag and drop your image
                    </p>
                  </div>
                ) : (
                  <div className="relative w-full h-64">
                    <Cropper
                      image={selectedImage}
                      crop={crop}
                      zoom={zoom}
                      aspect={3.3} // Aspect ratio: 1 (square)
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                    // onCropComplete={handleCropComplete}
                    />
                  </div>
                )}
              </div>

              {/* Popup Footer */}
              <div className="flex justify-between items-center px-4 py-2 border-t">
                <span className="text-sm text-gray-500">
                  Selected size: 1:1 (square)
                </span>
                <button
                  onClick={handleCropComplete}
                  className="bg-green-500 text-white px-4 py-2 rounded-md"
                >
                  Save Cropped Image
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Email Verification Popup */}
        {isEmailPopupOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2">
            <div className="relative w-full flex flex-col items-center max-w-md p-6 bg-white rounded shadow-lg">
              <button
                onClick={closeEmailPopup}
                className="absolute top-2 right-2 text-sm flex items-center justify-center w-6 h-6 rounded-sm border border-gray-400 bg-white text-gray-400 hover:border-gray-600 hover:text-gray-600 transition-all duration-200"
              >
                <IoClose />
              </button>
              <img src="/verificationEmail.png" className="w-52" alt="verificationEmailImg"/>

              <h2 className="mb-4 text-xl font-semibold tracking-wide text-center">
                Verify Email
              </h2>
              <p className="mb-4 text-center text-gray-600">
                Enter the OTP sent to your email.
              </p>
              <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                placeholder="Enter OTP"
                className="w-full px-4 py-2 mb-4 border rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              <button
                className="w-full px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
                onClick={handleEmailOtpSubmit}
              >
                Submit OTP
              </button>
            </div>
          </div>
        )}

        {/* Phone Verification Popup */}
        {isPhonePopupOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2">
            <div className="relative w-full flex flex-col items-center max-w-md p-6 bg-white rounded shadow-lg">
              <button
                onClick={closePhonePopup}
                className="absolute top-2 right-2 text-sm flex items-center justify-center w-6 h-6 rounded-sm border border-gray-400 bg-white text-gray-400 hover:border-gray-600 hover:text-gray-600 transition-all duration-200"
              >
                <IoClose />
              </button>
              <img src="verificationPhone.png" className="w-52" alt="verificationPhoneImg" />

              <h2 className="mb-4 text-xl ont-semibold tracking-wide text-center">
                Verify Phone
              </h2>
              <p className="mb-4 text-center text-gray-600">
                Enter the OTP sent to your phone.
              </p>
              <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                placeholder="Enter OTP"
                className="w-full px-4 py-2 mb-4 border rounded focus:outline-none focus:ring-1 focus:ring-green-500"
              />
              <button
                className="w-full px-4 py-2 text-white bg-green-500 rounded hover:bg-green-600"
                onClick={handlePhoneOtpSubmit}
              >
                Submit OTP
              </button>
            </div>
          </div>
        )}


        {/* Phone Change Popup */}
        {isPhoneChangePopupOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Change Phone Number</h2>
                <button onClick={() => setPhoneChangePopupOpen(false)}>✕</button>
              </div>
              <input
                type="tel"
                value={newPhone}
                // onChange={handlePhoneChange}
                onChange={(e) => setNewPhone(e.target.value)}
                placeholder="Enter new phone number"
                className="w-full px-4 py-2 mb-4 border rounded"
              />
              <button
                onClick={handlePhoneNumberChange}
                className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
              >
                Verify
              </button>
            </div>
          </div>
        )}

        {/* Verification Choice Popup */}
        {isVerifyChoicePopupOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Choose Verification Method</h2>
                <button onClick={() => setVerifyChoicePopupOpen(false)}>✕</button>
              </div>
              <div className="flex gap-4">
                <button
                  onClick={() => handleVerificationChoice("email")}
                  className="flex-1 bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
                >
                  Verify with Email
                </button>
                <button
                  onClick={() => handleVerificationChoice("phone")}
                  className="flex-1 bg-green-500 text-white py-2 rounded hover:bg-green-600"
                >
                  Verify with Phone
                </button>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default Account;

const TextContainer = ({ label, children }) => (
  <div className="capitalize font-semibold">
    <div className="text-sm font-semibold text-zinc-400 ">{label}</div>
    <div>{children}</div>
  </div>
);
